import { CONSTANTS } from "@/constants";
import { Banner } from "../Banner";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@netfront/apollo-providers";
import { UserFlowQueriesGetUserFlowByUrlArgs, UserFlowType } from "@netfront/api-ekardo-types";
import { gql } from "@apollo/client";

interface GetUserFlowsByUrlArgs extends Pick<UserFlowQueriesGetUserFlowByUrlArgs, 'projectId'> {
  studentEvaluationUrl: string;
  studentLessonsUrl: string;
};

export const StudentEvaluationBanner = () => {
  const { USERFLOW } = CONSTANTS;

  const [shouldShowBanner, setShouldShowBanner] = useState<boolean>(false);

  const { handleQuery: getUserFlowsByUrl } = useLazyQuery<
  {
    userFlow: {
      studentEvaluation: UserFlowType, 
      studentLessons: UserFlowType
    }
  },
    GetUserFlowsByUrlArgs
  >({
    apiName: 'ekardo',
    query: gql`
      query getUserFlowByUrl($projectId: String!, $studentEvaluationUrl: String!, $studentLessonsUrl: String!) {
        userFlow {
          studentEvaluation: getUserFlowByUrl(projectId: $projectId, url: $studentEvaluationUrl) {
           userFlowSteps {
              isComplete
            }
          }
          studentLessons: getUserFlowByUrl(projectId: $projectId, url: $studentLessonsUrl) {
           userFlowSteps {
              isComplete
              id
            }
          }
        }
      }
    `,
    onCompleted: ({ userFlow: { studentEvaluation, studentLessons } }) => {
      const isEvaluationComplete = !studentEvaluation.userFlowSteps.some(({ isComplete }) => !isComplete);
      const isLastLessonComplete = studentLessons.userFlowSteps.find(({ id }) => id === USERFLOW.CARTOONS.STEPS.LESSON_6.ID)?.isComplete ?? false;

      setShouldShowBanner(isLastLessonComplete && !isEvaluationComplete)
    }
  });

  useEffect(() => {
    getUserFlowsByUrl({
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      studentEvaluationUrl: USERFLOW.STUDENT_EVALUATION.URL,
      studentLessonsUrl: USERFLOW.CARTOONS.URL
    })
  }, []);
  
  return shouldShowBanner ? (
    <Banner 
      title='Evaluation'
      actions={[
        { 
          text: 'Start evaluation',  
          variant: 'dark',
          linkButton: {
            id: 'student-evalutation',
            url: '/student/evaluation/student-evaluation',
          }
        }
      ]}
    >
      <p>Congratulations on completing the program! Please complete the evaluation now</p>
    </Banner>
  ) : null
};